import { combineReducers } from 'redux';

import disabledQuestions from './AccountSettingsReducers/disabledQuestionsReducer';
import accountSettings from './AccountSettingsReducers/mainAccountSettingsReducer';
import myFriends from './AccountSettingsReducers/MyFriendsReducer';
import myProfile from './AccountSettingsReducers/myProfileReducer';
import notificationPreferences from './AccountSettingsReducers/notificationPreferencesReducer';
import banners from './bannerReducer';
import customAudioPlaylist from './customAudioPlaylistReducer';
import dailyQuiz from './dailyQuizReducer';
import activity from './DashboardReducers/activityReducer';
import badges from './DashboardReducers/badgesReducer';
import dailyQuizHistory from './DashboardReducers/dailyQuizHistoryReducer';
import dashboard from './DashboardReducers/dashboardReducer';
import DashboardFeaturedBlog from './DashboardReducers/featuredBlogReducer';
import inviteAFriend from './DashboardReducers/inviteAFriendReducer';
import leaderboard from './DashboardReducers/leaderboardReducer';
import myStats from './DashboardReducers/myStastsReducer';
import oneDailyQuizHistory from './DashboardReducers/oneDailyQuizHistoryReducer';
import practiceExamHistory from './DashboardReducers/practiceExamHistoryReducer';
import scoringHistory from './DashboardReducers/scoringHistoryReducer';
import friendActivity from './FriendProfileReducers/friendActivityReducer';
import friendBadges from './FriendProfileReducers/friendBadgesReducer';
import friendHeader from './FriendProfileReducers/friendHeaderReducer';
import friendProfile from './FriendProfileReducers/friendProfileReducer';
import friendScoringHistory from './FriendProfileReducers/friendScoringHistoryReducer';
import friendStats from './FriendProfileReducers/friendStatsReducer';
import helpPopoupsReducer from './helpPopoupsReducer';
import login from './loginReducer';
// reducers
import mainReducer from './mainReducer';
import manageSubscriptionReducer from './manageSubscriptionReducer';
import notificationsMessageReducer from './notificationMessageReducer';
import personalizedStudy from './personalizedStudyReducer';
import practiceExamReducer from './practiceExamReducer';
import referral from './referralReducer';
import resources from './resourcesReducer';
import selfPromotion from './selfPromotionReducer';
import signup from './signUpReducer';
import studyMain from './studyMainReducer';
import submitAQuestionReducer from './SubmitAQuestionReducers/submitAQuestionReducer';

export default (routerReducer) =>
  combineReducers({
    router: routerReducer,
    mainReducer,
    friendProfile,
    friendHeader,
    friendScoringHistory,
    friendBadges,
    friendStats,
    friendActivity,
    login,
    studyMain,
    dailyQuiz,
    dashboard,
    oneDailyQuizHistory,
    myStats,
    activity,
    leaderboard,
    accountSettings,
    banners,
    myProfile,
    disabledQuestions,
    scoringHistory,
    badges,
    dailyQuizHistory,
    practiceExamHistory,
    DashboardFeaturedBlog,
    inviteAFriend,
    helpPopoupsReducer,
    signup,
    notificationPreferences,
    practiceExamReducer,
    myFriends,
    manageSubscriptionReducer,
    resources,
    notificationsMessageReducer,
    submitAQuestionReducer,
    referral,
    customAudioPlaylist,
    personalizedStudy,
    selfPromotion,
  });
